import './Spinner.scss';

type Props = {
  theme: 'light' | 'dark' | 'blue';
  isBig?: boolean;
};

const Spinner = ({ theme, isBig }: Props) => (
  <div className={`spinner spinner_theme_${theme} ${isBig ? 'spinner_big' : ''}`} />
);

export { Spinner };
